export const CaseSubjectBreadCrumb = {
    CASE_SUBJECT: 'Case Subject',
    CASE_SUBJECT_DETAILS: 'Case Subject Details',
    CASE_SUBJECT_OVERVIEW: 'Overview',
    CASE_SUBJECT_CONNECTION: 'Connection',
    CASE_SUBJECT_HISTORY: 'History'
} as const;
